import React from 'react';
import scaleSize from '../../../utils/scale-size';

export default () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={scaleSize(48)}
    height={scaleSize(48)}
    viewBox="0 0 48 48"
  >
    <g
      className="stroke-change"
      fill="none"
      fillRule="evenodd"
      stroke="#9F9F9F"
      strokeWidth="3"
      transform="translate(8 8)"
    >
      <path strokeLinecap="round" d="M22 22l8 8" />
      <circle cx="13" cy="13" r="11.5" />
    </g>
  </svg>
);
